import {
  CaseReducer,
  CaseReducerWithPrepare,
  PayloadAction,
} from '@reduxjs/toolkit';

type ReducerImpl<State> =
  | CaseReducer<State, PayloadAction<any>>
  | CaseReducerWithPrepare<State, PayloadAction<any, string, any, any>>;

export const createSharedReducer = <S, T extends string>(
  actions: readonly T[],
  reducer: ReducerImpl<S>,
) =>
  actions.reduce(
    (prev, curr) => ({
      ...prev,
      [curr]: reducer,
    }),
    {},
  ) as Record<T, ReducerImpl<S>>;

export const setFetching = (fetching = true) => (state: {
  fetching?: boolean;
}) => {
  state.fetching = fetching;
};
